import { CompanyStatsModuleResponse } from '@business/entities/company_stats';
import { SettingsResponse } from '@business/entities/settings';
import { Endpoint } from '../endpoint';
import { COFormData } from '@modules/CompanyOverviewPage/EditCompanyOverviewItems/EditCompanyOverviewModal';

export function fetchModules(date?: number) {
  return Endpoint.get<CompanyStatsModuleResponse[]>(`@gc/company-stats`, { params: { date } });
}

export function updateNotifyEmails(emails: string[]) {
  return Endpoint.post<SettingsResponse>(`@gc/settings/stats-notify-emails`, { data: { emails } });
}

export function saveCOSettings(settings: COFormData) {
  return Endpoint.post<void>(`@gc/settings/company-stat-settings`, { data: { settings } });
}

export function fetchCOSettings() {
  return Endpoint.get<COFormData>(`@gc/settings/company-stat-settings`);
}
